var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostAnalysisOptimization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 67,
    viewBox: "0 0 56 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 26.6333,
    width: 8.88174,
    height: 39.7054,
    fill: "#092E40"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.543,
    y: 37.978,
    width: 8.88174,
    height: 28.361,
    fill: "#092E40"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.0859,
    y: 32.3057,
    width: 8.88174,
    height: 34.0332,
    fill: "#092E40"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6289,
    y: 45.9189,
    width: 8.88174,
    height: 20.4199,
    fill: "#092E40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10742 11.8857L21.6505 30.0368L36.6384 20.394L51.6263 34.5745M6.10742 11.8857H12.7687M6.10742 11.8857V18.6924M51.6263 34.5745V27.2007M51.6263 34.5745H45.5201",
    stroke: "#092E40",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0005 9.16335C35.0005 13.3111 31.6186 16.6822 27.436 16.6822C23.2534 16.6822 19.8715 13.3111 19.8715 9.16335C19.8715 5.01561 23.2534 1.64449 27.436 1.64449C31.6186 1.64449 35.0005 5.01561 35.0005 9.16335Z",
    stroke: "#092E40",
    strokeWidth: 1.90323
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3711 13.6973V12.4902C26.8867 12.4824 26.4395 12.4395 26.0293 12.3613C25.623 12.2793 25.2715 12.1738 24.9746 12.0449V10.7969C25.2754 10.9375 25.6465 11.0645 26.0879 11.1777C26.5293 11.291 26.957 11.3555 27.3711 11.3711V9.17383C26.8047 8.98242 26.3438 8.7832 25.9883 8.57617C25.6367 8.36914 25.3789 8.12891 25.2148 7.85547C25.0508 7.57812 24.9688 7.24609 24.9688 6.85938C24.9688 6.46094 25.0684 6.11914 25.2676 5.83398C25.4707 5.54492 25.752 5.31641 26.1113 5.14844C26.4746 4.98047 26.8945 4.88086 27.3711 4.84961V3.89453H28.1328V4.83203C28.5664 4.84375 28.9668 4.89258 29.334 4.97852C29.7051 5.06055 30.0586 5.17578 30.3945 5.32422L29.9668 6.41406C29.6738 6.29688 29.3691 6.20117 29.0527 6.12695C28.7363 6.05273 28.4297 6.00195 28.1328 5.97461V8.11914C28.6094 8.27539 29.0332 8.44336 29.4043 8.62305C29.7793 8.80273 30.0723 9.0293 30.2832 9.30273C30.498 9.57227 30.6055 9.92578 30.6055 10.3633C30.6055 10.9375 30.3945 11.4121 29.9727 11.7871C29.5508 12.1582 28.9375 12.3809 28.1328 12.4551V13.6973H27.3711ZM28.1328 11.3242C28.5078 11.2773 28.7871 11.1797 28.9707 11.0312C29.1543 10.8789 29.2461 10.6816 29.2461 10.4395C29.2461 10.2754 29.207 10.1367 29.1289 10.0234C29.0547 9.91016 28.9355 9.80859 28.7715 9.71875C28.6113 9.62891 28.3984 9.54102 28.1328 9.45508V11.3242ZM27.3711 7.83203V5.99805C27.1445 6.02148 26.9531 6.06836 26.7969 6.13867C26.6406 6.20898 26.5234 6.30078 26.4453 6.41406C26.3672 6.52734 26.3281 6.66211 26.3281 6.81836C26.3281 6.99023 26.3633 7.13672 26.4336 7.25781C26.5039 7.37891 26.6152 7.48438 26.7676 7.57422C26.9238 7.66406 27.125 7.75 27.3711 7.83203Z",
    fill: "#092E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostAnalysisOptimization);
export default __webpack_public_path__ + "static/media/cost-analysis-optimization.441ca10a56874dfed7eea083970feb1e.svg";
export { ForwardRef as ReactComponent };